import { useContext } from "react";

import { CurrentPatientContext } from "@/context/CurrentPatientContext";

export const useCurrentPatient = () => {
  const currentPatient = useContext(CurrentPatientContext);

  if (!currentPatient) {
    throw new Error("Could not get current Patient");
  }

  return currentPatient;
};
